import React from 'react';
import "../css/Sidebar.css";
import { AiFillHome } from "react-icons/ai";
import { RiLogoutBoxRFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import action from '../store/action';
import { withRouter } from './withRouter';
import { connect } from 'react-redux';
import store from '../store';

const Sidebar = (props) => {
    const navigate = useNavigate();
    const path = window.location.pathname;
    const logout = () => {
        store.dispatch(action.logout());
        navigate("/");
    };
    const nav = (to) => {
        navigate(to);
        if (props.onNavigate) props.onNavigate();
    };
    return (
        <div className='main-div-sidebar'>
            <div className='logo-flex'>
                <div className='sidebar'>
                    <div className='logo-sidebar'>
                        <svg className="sidebar-logo-svg" viewBox="0 0 180 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0" y="4" width="32" height="32" rx="8" fill="url(#logoGrad2)"/>
                            <path d="M10 20L15 25L24 14" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <text x="40" y="28" fontFamily="Inter, sans-serif" fontWeight="700" fontSize="18">
                                <tspan fill="#2563eb">Crypto</tspan><tspan fill="#0f172a">App</tspan>
                            </text>
                            <defs><linearGradient id="logoGrad2" x1="0" y1="4" x2="32" y2="36"><stop stopColor="#3b82f6"/><stop offset="1" stopColor="#1d4ed8"/></linearGradient></defs>
                        </svg>
                    </div>
                </div>
            </div>
            <div className='link-sidebar'>
                <div className={path === "/" ? "text-icon-sel" : 'text-icon'} onClick={() => nav("/")}>
                    <div className={path === "/" ? "side-bar-icon-sel" : 'side-bar-icon'}><AiFillHome /></div>
                    <p className={path === "/" ? "icon-para-sel" : 'icon-para'}>Dashboard</p>
                </div>
                <div className="sidebar-spacer" />
                <div onClick={logout} className='text-icon text-icon-logout'>
                    <div className='side-bar-icon'><RiLogoutBoxRFill /></div>
                    <p className='icon-para'>Logout</p>
                </div>
            </div>
        </div>
    )
}
const mapStatetoProps = (state) => ({ user: state.user, lang: state.lang });
const mapDispatchtoProps = (dispatch) => ({ logout: () => dispatch(action.logout()) });
export default connect(mapStatetoProps, mapDispatchtoProps)(withRouter(Sidebar));
